import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../../environments/environment";
import { Observable } from "rxjs";
import {
  ITasksResponse,
  ITaskLinesResponse,
  ITaskLineResponse,
  ITaskLineDeleteResponse,
  ITaskLineRequest,
  ITaskAsesorsResponse,
  ITaskTypeDeleteResponse,
  ITaskTypeResponse,
  ITaskTypeRequest,
  ITaskTypesResponse,
  ITaskRequest,
  ITaskResponse,
  ITaskDeleteResponse,
  ITaskHistoryResponse,
  ITaskHistoryRequest,
  ITaskHistoryCreateResponse,
  ITasksExportProspectsResponse,
  ITasksTopbarResponse,
  ITasksExportResponse,
  ITaskFinishRequest,
  ITaskFinishResponse,
  ITaskCustomerBasicInfoResponse,
  ITaskFileResponse,
} from "../../master-models/task.model";

@Injectable()
export class TaskService {
  url = `${environment.apiBaseUrl}api`;
  urlTask = `${this.url}/tasks`;
  urlTaskLine = `${this.url}/task_lines`;
  urlTaskType = `${this.url}/task_types`;
  urlTaskFilter = `${this.url}/tasks_filter`;

  constructor(private http: HttpClient) {}

  getTasks(page: number = 1): Observable<ITasksResponse> {
    return this.http.get<ITasksResponse>(this.urlTask, {
      headers: this.getHeaders(),
      params: {
        page: page.toString(),
      },
    });
  }
  
  getTopbarTasks(): Observable<ITasksTopbarResponse> {
    return this.http.get<ITasksTopbarResponse>(`${this.url}/tasks_topbar`, {
      headers: this.getHeaders(),
    });
  }

  getTasksFilter(filters: any, page: number = 1): Observable<ITasksResponse> {
    const params: any = { page: page.toString() };

    if (filters.asesor_id != null && filters.asesor_id !== '') {
      params.user_asigned_id = filters.asesor_id.toString();
    }
    if (filters.date_from) {
      params.created_at_from = filters.date_from;
    }
    if (filters.date_to) {
      params.created_at_to = filters.date_to;
    }
    if (filters.name) {
      params.name = filters.name;
    }
    if (filters.task_lines_id != null && filters.task_lines_id !== '') {
      params.task_lines_id = filters.task_lines_id.toString();
    }
    if (filters.task_types_id != null && filters.task_types_id !== '') {
      params.task_types_id = filters.task_types_id.toString();
    }
    if (filters.origin_id != null && filters.origin_id !== '') {
      params.origin_id = filters.origin_id.toString();
    }
    if (filters.state != null && filters.state !== '') {
      params.state = filters.state.toString();
    }
    if (filters.priority != null && filters.priority !== '') {
      params.priority = filters.priority.toString();
    }

    return this.http.get<ITasksResponse>(this.urlTaskFilter, {
      headers: this.getHeaders(),
      params,
    });
  }

  getTaskLines(): Observable<ITaskLinesResponse> {
    return this.http.get<ITaskLinesResponse>(this.urlTaskLine, {
      headers: this.getHeaders(),
    });
  }

  createTaskLine(data: ITaskLineRequest): Observable<ITaskLineResponse> {
    return this.http.post<ITaskLineResponse>(
      this.urlTaskLine,
      data,
      {
        headers: this.getHeaders(),
      }
    );
  }

  updateTaskLine(
    id: number,
    data: ITaskLineRequest
  ): Observable<ITaskLineResponse> {
    return this.http.put<ITaskLineResponse>(
      `${this.urlTaskLine}/${id}`,
      data,
      {
        headers: this.getHeaders(),
      }
    );
  }

  deleteTaskLine(id: number): Observable<ITaskLineDeleteResponse> {
    return this.http.delete<ITaskLineDeleteResponse>(
      `${this.urlTaskLine}/${id}`,
      {
        headers: this.getHeaders(),
      }
    );
  }
  
  getTaskTypes(): Observable<ITaskTypesResponse> {
    return this.http.get<ITaskTypesResponse>(this.urlTaskType, {
      headers: this.getHeaders(),
    });
  }

  createTaskType(data: ITaskTypeRequest): Observable<ITaskTypeResponse> {
    return this.http.post<ITaskTypeResponse>(
      this.urlTaskType,
      data,
      {
        headers: this.getHeaders(),
      }
    );
  }

  updateTaskType(
    id: number,
    data: ITaskTypeRequest
  ): Observable<ITaskTypeResponse> {
    return this.http.put<ITaskTypeResponse>(
      `${this.urlTaskType}/${id}`,
      data,
      {
        headers: this.getHeaders(),
      }
    );
  }

  deleteTaskType(id: number): Observable<ITaskTypeDeleteResponse> {
    return this.http.delete<ITaskTypeDeleteResponse>(
      `${this.urlTaskType}/${id}`,
      {
        headers: this.getHeaders(),
      }
    );
  }

  getTaskAsesors(): Observable<ITaskAsesorsResponse> {
    return this.http.get<ITaskAsesorsResponse>(`${this.url}/task_asesor_users`, {
      headers: this.getHeaders(),
    });
  }

  createTask(data: ITaskRequest | FormData): Observable<ITaskResponse> {
    return this.http.post<ITaskResponse>(this.urlTask, data, {
      headers: this.getHeaders(),
    });
  }

  updateTask(id: number, data: ITaskRequest): Observable<ITaskResponse> {
    return this.http.put<ITaskResponse>(`${this.urlTask}/${id}`, data, {
      headers: this.getHeaders(),
    });
  }

  deleteTask(id: number): Observable<ITaskDeleteResponse> {
    return this.http.delete<ITaskDeleteResponse>(`${this.urlTask}/${id}`, {
      headers: this.getHeaders(),
    });
  }

  getHistoryByTaskId(taskId: number): Observable<ITaskHistoryResponse> {
    return this.http.get<ITaskHistoryResponse>(`${this.url}/task_history_by_task/${taskId}`, {
      headers: this.getHeaders(),
    });
  }

  getTasksExport(filters: any): Observable<ITasksExportResponse> {
    const params: any = {};

    if (filters.asesor_id != null && filters.asesor_id !== '') {
      params.user_asigned_id = filters.asesor_id.toString();
    }
    if (filters.date_from) {
      params.created_at_from = filters.date_from;
    }
    if (filters.date_to) {
      params.created_at_to = filters.date_to;
    }
    if (filters.name) {
      params.name = filters.name;
    }
    if (filters.task_lines_id != null && filters.task_lines_id !== '') {
      params.task_lines_id = filters.task_lines_id.toString();
    }
    if (filters.task_types_id != null && filters.task_types_id !== '') {
      params.task_types_id = filters.task_types_id.toString();
    }
    if (filters.origin_id != null && filters.origin_id !== '') {
      params.origin_id = filters.origin_id.toString();
    }
    if (filters.state != null && filters.state !== '') {
      params.state = filters.state.toString();
    }
    if (filters.priority != null && filters.priority !== '') {
      params.priority = filters.priority.toString();
    }

    return this.http.get<ITasksExportResponse>(`${this.url}/tasks_export`, {
      headers: this.getHeaders(),
      params,
    });
  }

  createTaskHistory(data: ITaskHistoryRequest): Observable<ITaskHistoryCreateResponse> {
    return this.http.post<ITaskHistoryCreateResponse>(`${this.url}/task_history`, data, {
      headers: this.getHeaders(),
    });
  }

  finishTask(id: number, data: ITaskFinishRequest): Observable<ITaskFinishResponse> {
    return this.http.post<ITaskFinishResponse>(`${this.url}/tasks_finish/${id}`, data, {
      headers: this.getHeaders(),
    });
  }

  getHeaders(): HttpHeaders {
    const token = localStorage.getItem("token_user");

    return new HttpHeaders({
      Authorization: `Bearer ${token}`,
      Accept: "application/json",
    });
  }

  getCustomersBasicInfo(): Observable<ITaskCustomerBasicInfoResponse> {
    return this.http.get<ITaskCustomerBasicInfoResponse>(`${this.url}/customers_basic_info`, {
      headers: this.getHeaders(),
    });
  }

  getTasksProspects(): Observable<ITasksExportProspectsResponse> {
    return this.http.get<ITasksExportProspectsResponse>(`${this.url}/tasks_prospects`, {
      headers: this.getHeaders(),
    });
  }

  getTaskFiles(taskId: number): Observable<ITaskFileResponse> {
    return this.http.get<ITaskFileResponse>(`${this.url}/tasks_files/${taskId}`, {
      headers: this.getHeaders(),
    });
  }
}


// WEBPACK FOOTER //
// ./src/app/master-services/tasks/task.service.ts